import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
import { FancyButton } from '../../pages';

/**
 * Ministry Enrollment modal — extracted from App.js HomePage (Feb 2026 P3 refactor).
 * Shown when a visitor clicks "Join" on a ministry card.
 */
const MinistryEnrollmentModal = ({
  open, ministry, form, onFormChange, onSubmit, onClose,
}) => (
  <AnimatePresence>
    {open && ministry && (
      <div
        data-testid="ministry-enrollment-modal"
        className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-0 sm:p-4"
      >
        <motion.div
          className="bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl w-full sm:max-w-md p-4 sm:p-6 max-h-[90vh] overflow-y-auto"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl sm:text-2xl font-bold text-purple-900 pr-2">
              Join {ministry.name}
            </h3>
            <button
              onClick={onClose}
              data-testid="ministry-enrollment-modal-close"
              className="p-2 rounded-xl hover:bg-slate-100 transition-colors"
            >
              <X className="w-6 h-6 text-slate-600" />
            </button>
          </div>

          <p className="text-slate-600 mb-6">{ministry.description}</p>

          <div className="space-y-4">
            <input
              className="w-full border-2 border-purple-200 rounded-xl px-4 py-3 focus:border-purple-400 transition-colors"
              placeholder="Your Full Name *"
              value={form.member_name}
              onChange={(e) => onFormChange({ member_name: e.target.value })}
              data-testid="ministry-enrollment-name"
            />
            <input
              className="w-full border-2 border-purple-200 rounded-xl px-4 py-3 focus:border-purple-400 transition-colors"
              placeholder="Your Phone Number *"
              value={form.member_phone}
              onChange={(e) => onFormChange({ member_phone: e.target.value })}
              data-testid="ministry-enrollment-phone"
            />
            <input
              className="w-full border-2 border-purple-200 rounded-xl px-4 py-3 focus:border-purple-400 transition-colors"
              placeholder="Your Email (optional)"
              value={form.member_email}
              onChange={(e) => onFormChange({ member_email: e.target.value })}
              data-testid="ministry-enrollment-email"
            />

            <FancyButton
              onClick={onSubmit}
              variant="royal"
              className="w-full flex items-center justify-center gap-2"
              data-testid="ministry-enrollment-submit"
            >
              <CheckCircle2 className="w-5 h-5" />
              <span>Submit Enrollment</span>
            </FancyButton>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default MinistryEnrollmentModal;
